import type {PublicMethodUtils} from '@wix/document-services-types'

export default function (publicMethodUtils: PublicMethodUtils) {
    const {
        extensionPublicAPI: {immediate, getter}
    } = publicMethodUtils

    return {
        methods: {
            /** @class documentServices.bindings*/
            bindings: {
                /**
                 * Binds a context to a component, the bindingMap will be merged to the existing bindings
                 * It can be used to bind a context to a component for the first time
                 * @member documentServices.bindings.bind
                 * @param {CompRef} componentPointer - the component to bind the context to
                 * @param {string} contextType - the context to bind to the component
                 * @param {Object} bindingsMap - a key value map from component property to a context property
                 */
                bind: immediate('bindings.bind'),
                /**
                 * Binds a context to a component, the bindingMap will replace the existing bindings
                 * It can be used to bind a context to a component for the first time
                 * @member documentServices.bindings.bindAll
                 * @param {CompRef} componentPointer - the component to bind the context to
                 * @param {string} contextType - the context to bind to the component
                 * @param {Object} bindingsMap - a key value map from component property to a context property
                 */
                bindAll: immediate('bindings.bindAll'),
                /**
                 * Unbinds specific properties of a specific context from a component
                 * It does not remove the bindingMap itself
                 * @member documentServices.bindings.unbindProperties
                 * @param {CompRef} componentPointer - the component to unbind the context from
                 * @param {string} contextType - the context to unbind from the component
                 * @param {string[]} properties - a list of properties to unbind from the component
                 */
                unbindProperties: immediate('bindings.unbindProperties'),
                /**
                 * Returns all the bindings of a component
                 * @member documentServices.bindings.getBoundProperties
                 * @param {CompRef} componentPointer - the component whose bindings are requested
                 * @returns {Object} - a map of all bindings by context provider name
                 */
                getBoundProperties: getter('bindings.getBoundProperties')
            }
        }
    }
}
